<template>
	<div v-if="!hideSuccess" id="successContainer" class="alert alert-success text-center" :class="{ 'hide': hideSuccess }" role="alert">
		<svgIcon iconHolderClass="icon-warning" iconId="icon-warning"/>
		{{ successCode }}
		<slot/>
	</div>
</template>

<script>
import svgIcon from './icon-svg';

export default {
	name: 'formSuccess',
	components: {
		svgIcon
	},
	props: {
		hideSuccess: {
			type: Boolean,
			default: true,
			note: 'Hide and show success'
		},
		successCode: {
			type: String,
			default: '',
			note: 'Message when it shows.'
		}
	},
	watch: {
		successCode() {
			const container = document.getElementById('successContainer');

			if (container !== null) {
				container.scrollIntoView({
					behavior: 'smooth'
				});
			}
		}
	},
	created() {
		if (!this.successCode) {
			this.hideSuccess = true;
		}
	}
};
</script>

<style lang="less" scoped>
	.alert {
		width: 100%;
	}
	@media (max-width: 740px) {
		.alert {
			margin-bottom: 0;
		}
	}
</style>
